import { TDeviceType } from '@cian/ui-kit';

import { IApplicationState } from '../../types/redux';
import { selectIsOffersLoaded } from '../listingOffers';

/**
 * На мобвебе листинг и карта НЕ синхронизируются: если листинг уже пришёл с SSR (SEO-ссылка),
 * на первой загрузке карты его НЕ перезагружаем по пинам — избегаем двойной загрузки и мелькания
 * SSR-офферов (на мобвебе нет подсветки пинов при наведении на листинг, синхронность не нужна).
 * На десктопе листинг синхронизируется с картой (подсветка пинов), поэтому всегда false.
 */
export function selectShouldKeepSsrListing(state: IApplicationState, deviceType: TDeviceType): boolean {
  return deviceType !== 'desktop' && selectIsOffersLoaded(state);
}
